import { useMediaQuery, useTheme } from '@mui/material';

import { Icon } from '@hapvida/hapvida-core-components';

import { NEW_COLORS } from '@hapvida/hapvida-core-components/src/themes/colors/newColors';

import { IconContainer, ButtonContainer, QuickActionText } from './styles';
import type { QuickActionButtonProps } from './types';

const QuickActionButton = ({
  iconName,
  text,
  ...buttonBaseProps
}: QuickActionButtonProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'), {
    noSsr: true,
  });
  return (
    <ButtonContainer {...buttonBaseProps}>
      <IconContainer>
        <Icon color={NEW_COLORS.SECONDARY[500]} name={iconName} size={24} />
      </IconContainer>

      <QuickActionText variant="body2" noWrap flex={1} textAlign="left">
        {text}
      </QuickActionText>

      {!isMobile && (
        <Icon
          color={NEW_COLORS.GRAYSCALE[600]}
          name={'actions-b2b-chevron-right'}
          size={24}
        />
      )}
    </ButtonContainer>
  );
};

export default QuickActionButton;
